module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Medium.201ae033.ttf";